/**
 * Iedereen die op een afspraak staat, als lijst van persona-ID's.
 *
 * Er zijn twee velden en ze sluiten elkaar niet uit. `PersonaID` draagt in de
 * praktijk vrijwel alleen roosterregels (platformbreed 483 van de 491), en een
 * huisbezoek zet zijn mensen in `TeamMembers` — `buildAdressVisitTask` zet
 * `PersonaID` daar zelfs expliciet op null. Een filter dat maar naar één van de
 * twee keek, liet daarom precies de bezoeken weg: wie op zichzelf filterde zag
 * zijn roosterregel en geen enkel bezoek. Bij Duurzame Vecht 0 van de 44.
 *
 * Eén helper voor beide filters (medewerker én rol), zodat die twee niet ieder
 * hun eigen antwoord gaan geven op dezelfde vraag.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {{PersonaID?: string|null, TeamMembers?: Array<string>}|null|undefined} task
 * @returns {Array<string>} De ID's, zonder dubbele en zonder lege waarden
 */
const taskPersonaIds = (task) => {
    const uit = []

    if (task?.PersonaID) uit.push(task.PersonaID)
    if (Array.isArray(task?.TeamMembers)) uit.push(...task.TeamMembers)

    // Een lege string of null is geen persoon. Zonder deze zeef doet '' mee als
    // sleutel en slaagt een rol-opzoeking op niets.
    return [...new Set(uit.filter(Boolean))]
}

export default taskPersonaIds
